import BaseException from "./BaseException";

export default class BusinessLogicException extends BaseException {
    public constructor(message: string, public readonly cause: any) {
        super(message, cause);
    }
}
